import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
  InMemoryBoolean,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from "@/plugins/i18n";

const ContributionCategoriesHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.category",
    type: new InMemoryString("Category"),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.employers",
    type: new InMemoryString("Employers/Translations[]/Name", {
      getString: (item) => {
        if (item.Employers === null || item.Employers === undefined) {
          return "";
        }
        return item.Employers.map((o) => translate2(o, "Name")).join(", ");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 400px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: false,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.stores",
    type: new InMemoryString("Stores/Translations[]/Name", {
      getString: (item) => {
        if (item.Stores === null || item.Stores === undefined) {
          return "";
        }
        return item.Stores.map((o) => translate2(o, "Name")).join(", ");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 400px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: false,
    searchable: true,
  }),
];
export default ContributionCategoriesHeaders;
